import { render, staticRenderFns } from "./PublicUptate.vue?vue&type=template&id=ded530a0&scoped=true&"
import script from "./PublicUptate.vue?vue&type=script&lang=ts&"
export * from "./PublicUptate.vue?vue&type=script&lang=ts&"
import style0 from "./PublicUptate.vue?vue&type=style&index=0&id=ded530a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded530a0",
  null
  
)

export default component.exports